import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('camelCaseToHuman', camelCaseToHuman);

function camelCaseToHuman() {
  return function (text) {
    if (!text) {
      return '';
    }
    //http://stackoverflow.com/questions/4149276/javascript-camelcase-to-regular-form
    return text.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
      return str.toUpperCase();
    })
  }
}
